import Modal from "react-bootstrap/Modal";
import RefereeDetailsElement from "../components/RefereeDetailsElement";
import RefereeEventsElement from "../components/RefereeEventsElement";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { ButtonModalClose } from "../components/ButtonModalClose";
import { useState } from "react";

export const UserRefereeDetailModal = ({ visible, close, referee, user, onRefereeUpdate }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefereeUpdate = () => {
    setRefreshTrigger(prev => prev + 1);
    if (onRefereeUpdate) {
      onRefereeUpdate();
    }
  };

  const selectDisplay = () => {
    return (
      <div>
        <RefereeDetailsElement
          refereeId={referee?.id}
          user={user}
          onRefereeUpdate={handleRefereeUpdate}
        />
        <div className="mt-4">
          <RefereeEventsElement
            refereeId={referee?.id}
            user={user}
            refreshTrigger={refreshTrigger}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize text-axis-offblack"}
        >
          Reference: {referee?.refereeName || 'Unknown'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{selectDisplay()}</Modal.Body>
      <Modal.Footer>
        <Row className={"w-100"}>
          <Col>
            <ButtonModalClose
              className={"w-100"}
              buttonText={"Close"}
              close={close}
            />
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};